import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Cookies from "js-cookie";

import LoginPage from "./components/GeneralComponents/LoginPage/LoginPage";
import SmallBoats from "./containers/DataBaseContainers/SmallBoats/SmallBoats";
import Certificates from "./containers/DataBaseContainers/CertificatesContainer/CertificatesContainer";
import BasesBuildings from "./containers/DataBaseContainers/BasesBuildings/BasesBuildings";
import Certificate from "./components/DataBaseComponents/Certificate/Certificate";
import Header from "./components/GeneralComponents/Header/Header";
import Sidebar from "./components/GeneralComponents/Sidebar/Sidebar";
import SmallBoatsRegistration from "./containers/AdministrativeProcedures/SmallBoatsRegistration/SmallBoatsRegistration";
import RegistrationInformationChanges from "./containers/AdministrativeProcedures/RegistrationInformationChanges/RegistrationInformationChanges";
import FormSearchBoatCard from "./containers/FormSearchBoatCard/FormSearchBoatCard";
import IndividualStatement from "./components/AdministrativeProcedures/registrationInformationChanges/IndividualStatement/IndividualStatement";
import TechnicalExaminationContainer from "./containers/AdministrativeProcedures/TechnicalExaminationContainer/TechnicalExaminationContainer";
import NSI from "./containers/NSI/NSI";
import ClassificationBoats from "./components/NSI/ClassificationBoats/ClassificationBoats";
import Legislation from "./components/NSI/Legislation/Legislation";
import Forms from "./components/NSI/Forms/Forms";
import PaidProcedures from "./components/NSI/PaidProcedures/PaidProcedures";
import Requisite from "./components/NSI/Requisites/Requisites";
import Contacts from "./components/NSI/Contacts/Contacts";
import SectionInfo from "./components/NSI/Contacts/SectionInfo/SectionInfo";
import AdministrativeProcedures from "./components/NSI/AdministrativeProcedures/AdministrativeProcedures";
import DuplicateShipsTicket from "./containers/AdministrativeProcedures/DuplicateShipsTicket/DuplicateShipsTicket";
import ShipsTicket from "./containers/AdministrativeProcedures/ShipsTicket/ShipsTicket";
import ProvisionInformation from "./containers/AdministrativeProcedures/ProvisionInformation/ProvisionInformation";
import InspectorWorkStat from "./components/StatisticsAnalytics/InspectorWorkStat/InspectorWorkStat";
import Reports from "./containers/StatisticsContainers/Reports/Reports";
import TransportAccidentsReport from "./containers/StatisticsContainers/TransportAccidentsReport/TransportAccidentsReport";
import WeeklyReport from "./containers/StatisticsContainers/WeeklyReport/WeeklyReport";
import ReportTrafficAccidents from "./containers/StatisticsContainers/ReportTrafficAccidents/ReportTrafficAccidents";
import CertificateIssuanceReport from "./containers/StatisticsContainers/CertificateIssuanceReport/CertificateIssuanceReport";
import QuarterlyReport from "./containers/StatisticsContainers/QuarterlyReport/QuarterlyReport";
import GraphsReport from "./containers/StatisticsContainers/GraphsReport/GraphsReport";
import ShortReport from "./containers/StatisticsContainers/ShortReport/ShortReport";
import SearchApplicationTraining from "./containers/KnowledgeTest/applicationTraining/searchApplicationTraining/SearchApplicationTraining";
import RegisterOfTrainees from "./containers/KnowledgeTest/RegisterOfTrainees/RegisterOfTrainees";
import SearchExpulsionOrder from "./containers/KnowledgeTest/listenerTracking/searchExpulsionOrder/SearchExpulsionOrder";
import CardExpulsionOrder from "./containers/KnowledgeTest/listenerTracking/сardExpulsionOrder/CardExpulsionOrder";
import SearchListener from "./containers/KnowledgeTest/listenerTracking/searchListener/SearchListener";
import RecordTrainedUsersLogbook from "./containers/KnowledgeTest/recordTrainedUsersLogbook/RecordTrainedUsersLogbook";
import SearchRecordTrainedUsers from "./containers/KnowledgeTest/recordTrainedUsers/searchRecordTrainedUsers/SearchRecordTrainedUsers";
import AppKnowledgeVerificationSearch from "./containers/KnowledgeTest/appKnowledgeVerificationSearch/AppKnowledgeVerificationSearch";
import AppKnowledgeVerification from "./components/knowledgeTestComponents/appKnowledgeVerification/AppKnowledgeVerification";
import IssuingCertificatesSearch from "./containers/AdministrativeProcedures/issuingCertificatesSearch/IssuingCertificatesSearch";
import AppBoatRegistrationRHF from "./components/AdministrativeProcedures/appBoatRegistrationRHF/AppBoatRegistrationRHF";
import ManagementTemplates from "./components/administration/managementTemplates/ManagementTemplates";

import {
  getDictionaryGimsSections,
  getDictionaryNsiCheckStatus,
  getDictionaryOwnerType,
  getUsersLibrary,
  getApplicationRegLibrary,
  getTrainingProgramLibrary,
  getStatusForIssuanceCertificates,
  getValidZonesLibrary,
  getValidTypesLibrary,
  getGimsDepartmentAll,
  getAllOblast,
  getAllGimsUserPositions,
  getAllSwimmingDifficultyCategory,
  getAllPreparationPrograms,
  getAllIdentificationDocuments,
  getAllPaymentDetails,
  getAllLocalityCategory,
  getAllBoatTypes,
  getAllMedConditions,
  getAllTrainingDocTypes,
  getAllEngineTypes,
  getAllBoatBodyMaterial,
  getAllKindsBoats,
  getAllRoles,
  logoutUserById,
  getAuditObject,
  getAllRangeMS,
  getAllTrainingExamTypes,
  getAllBillStatus,
  getAllPaidProcTypes,
  getAllInfPaymentAp,
  getAllCountries,
  getAllTrainingOrganizations,
  getAllAuditSecurityEvents,
  getGimsSubLevels,
} from "./redux/actions";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CardRecordTrainedUsers from "./containers/KnowledgeTest/recordTrainedUsers/cardRecordTrainedUsers/CardRecordTrainedUsers";
import SearchKnowledgeTestRecord from "./containers/KnowledgeTest/knowledgeTestRecord/searchKnowledgeTestRecord/SearchKnowledgeTestRecord";
import FormSearchApplicant from "./containers/formSearchApplicant/FormSearchApplicant";
import CardKnowledgeTestRecord from "./containers/KnowledgeTest/knowledgeTestRecord/cardKnowledgeTestRecord/CardKnowledgeTestRecord";
import SearchPeopleForTest from "./containers/KnowledgeTest/knowledgeTestRecord/searchPeopleForTest/SearchPeopleForTest";
import TrainingReport from "./containers/StatisticsContainers/trainingReport/TrainingReport";
import SearchCertificatesForPrint from "./containers/AdministrativeProcedures/printCertificates/SearchCertificatesForPrint/SearchCertificatesForPrint";
import InspectionTechnicalConditionBases from "./components/checksAuditsComponents/inspectionTechnicalConditionBases/inspectionTechnicalConditionBases";
import CertificateCardForPrint from "./containers/AdministrativeProcedures/printCertificates/CertificateCardForPrint/CertificateCardForPrint";
import ExchangeCertificatesSearch from "./containers/AdministrativeProcedures/exchangeCertificatesSearch/ExchangeCertificatesSearch";
import DuplicateCertificatesSearch from "./containers/AdministrativeProcedures/duplicateCertificatesSearch/DuplicateCertificatesSearch";
import LogbookAdministrativeProcedures from "./containers/AdministrativeProcedures/logbookAdministrativeProcedures/logbookAdministrativeProcedures";
import MaintainingDirectories from "./components/administration/maintainingDirectories/maintainingDirectories";
import RoleManagement from "./components/administration/roleManagement/roleManagement";
import AccountManagement from "./components/administration/accountManagement/accountManagement";
import AuditActionsSystem from "./containers/administration/auditActionsSystem/auditActionsSystem";
import PageRedirection from "./services/pageRedirection";
import StructuralUnits from "./containers/administration/maintainingDirectories/structuralUnits/structuralUnits";
import GimsSections from "./containers/administration/maintainingDirectories/gimsSections/gimsSections";
import AdministrativeDistricts from "./containers/administration/maintainingDirectories/administrativeDistricts/administrativeDistricts";
import IdentificationDocuments from "./containers/administration/maintainingDirectories/identificationDocuments/IdentificationDocuments";
import Positions from "./containers/administration/maintainingDirectories/positions/positions";
import SwimmingDifficultyCategory from "./containers/administration/maintainingDirectories/swimmingDifficultyCategory/swimmingDifficultyCategory";
import PreparationPrograms from "./containers/administration/maintainingDirectories/preparationPrograms/preparationPrograms";
import PaymentDetails from "./containers/administration/maintainingDirectories/paymentDetails/paymentDetails";
import Settlements from "./containers/administration/maintainingDirectories/settlements/settlements";
import MedConditions from "./containers/administration/maintainingDirectories/medConditions/medConditions";
import TrainingDocTypes from "./containers/administration/maintainingDirectories/trainingDocTypes/trainingDocTypes";
import BoatTypes from "./containers/administration/maintainingDirectories/boatTypes/BoatTypes";
import KindsBoats from "./containers/administration/maintainingDirectories/kindsBoats/KindsBoats";
import EngineType from "./containers/administration/maintainingDirectories/engineType/engineType";
import BoatBodyMaterial from "./containers/administration/maintainingDirectories/boatBodyMaterial/boatBodyMaterial";
import WorkingPage from "./containers/administration/accountManagement/workingPage/workingPage";
import FirstLoginPage from "./components/GeneralComponents/LoginPage/firstLoginPage/firstLoginPage";
import AuditSecurity from "./components/administration/auditSecurity/auditSecurity";
import NotificationWindow from "./components/GeneralComponents/NotificationWindow/NotificationWindow";
import BoatInfo from "./components/DataBaseComponents/boatInfo/BoatInfo";
import PrivateRoute from "./services/privateRoute";
import AccessDenied from "./services/accessDenied";
import DepartmentInfo from "./components/NSI/Contacts/departmentInfo/DepartmentInfo";
import RangeMS from "./containers/administration/maintainingDirectories/rangeMS/rangeMS";
import IssuingCertificatesAppRHF from "./components/AdministrativeProcedures/issuingCertificatesAppRHF/IssuingCertificatesAppRHF";
import ExchangeCertificatesAppRHF from "./components/AdministrativeProcedures/exchangeCertificatesAppRHF/ExchangeCertificatesAppRHF";
import DuplicateCertificatesAppRHF from "./components/AdministrativeProcedures/duplicateCertificatesAppRHF/DuplicateCertificatesAppRHF";
import DecisionCardRHF from "./components/AdministrativeProcedures/commonComponents/decisionCardRHF/DecisionCardRHF";
import CardApplicationTrainingRHF from "./containers/KnowledgeTest/applicationTraining/cardApplicationTrainingRHF/CardApplicationTrainingRHF";
import AppKnowledgeVerificationRHF from "./components/knowledgeTestComponents/appKnowledgeVerificationRHF/AppKnowledgeVerificationRHF";
import DuplShipsTicketRHF from "./components/AdministrativeProcedures/duplShipsTicketRHF/DuplShipsTicketRHF";
import TechnicalExaminationAppRHF from "./components/AdministrativeProcedures/technicalExaminationAppRHF/TechnicalExaminationAppRHF";
import StatementProvisionInformationRHF from "./components/AdministrativeProcedures/statementProvisionInformationRHF/StatementProvisionInformationRHF";
import PaidServicesReport from "./containers/StatisticsContainers/PaidServicesReport/PaidServicesReport";
import TransportAccidentFormRHF from "./components/StatisticsAnalytics/transportAccidentFormRHF/transportAccidentFormRHF";
import RegistrationChangesInformationRHFNew from "./components/AdministrativeProcedures/registrationChangesInformation/registrationChangesInformationRHFNew";
import Countries from "./containers/administration/maintainingDirectories/countries/countries";
import Organizations from "./containers/administration/maintainingDirectories/organizations/organizations";
import MaintenancePage from "./components/maintenancePage/maintenancePage";

import { getAuditSecurityInactionUser } from "./redux/auditSecurityReducer/actionsAuditSecurity";
import { actionRefreshToken, actionResetTokenError } from "./redux/loginReduser/actionRefreshToken";
import { getUserInfoById } from "./redux/userReducer/actionsUser";
import { getMenuNames, getMenuStructByUserId } from "./redux/roleControllerReducer/actionsRoleController";
import { getNsiAp } from "./redux/actions";
import {
  availableChaptersByUseId,
  menuActionsAll,
  menuChaptersAll,
} from "./redux/roleManagementReducer/actionsRoleManagement";

const isMaintenance = false;

function App() {
  const dispatch = useDispatch();

  const [isLogin, setIsLoginApp] = useState(
    window.location.pathname.includes("login") || window.location.pathname === "/" ? "" : "login",
  );
  const [showNotificationWindow, setShowNotificationWindow] = useState(false);
  const [textNotificationWindow, setTextNotificationWindow] = useState("");

  const authLoginReducer = useSelector((state) => {
    const { authLoginReducer } = state;
    return authLoginReducer;
  });

  const refreshToken = Cookies.get("refreshToken");
  const userId = Cookies.get("userId");
  const isAuthorized = Cookies.get("isAuthorized");

  const handleLogin = (value) => {
    setIsLoginApp(value);
  };

  const handleInactivityTimeout = () => {
    setTextNotificationWindow(
      `Внимание! 
        Бездействие в системе более часа! 
        Сеанс будет завершен!`,
    );

    dispatch(getAuditSecurityInactionUser());
    dispatch(logoutUserById(userId));

    setShowNotificationWindow(true);
  };

  const closeInactivityNotification = () => {
    setIsLoginApp("");
    setShowNotificationWindow(false);
    dispatch(actionResetTokenError());
  };

  useEffect(() => {
    if (authLoginReducer.authData.tokenError.length > 0) {
      setTextNotificationWindow(authLoginReducer.authData.tokenError);
      setShowNotificationWindow(true);
    }
  }, [authLoginReducer, authLoginReducer.authData.tokenError]);

  useEffect(() => {
    if (!authLoginReducer.authData.isLogin || isMaintenance) return;

    let inactivityTimer = setTimeout(handleInactivityTimeout, 60 * 60 * 1000);

    const handleUserActivity = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(handleInactivityTimeout, 60 * 60 * 1000);
    };

    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);

    return () => {
      clearTimeout(inactivityTimer);
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
    };
  }, [authLoginReducer.authData.isLogin, isMaintenance]);

  useEffect(() => {
    if (refreshToken && authLoginReducer.authData.isLogin && !isMaintenance) {
      dispatch(getDictionaryNsiCheckStatus());
      dispatch(getStatusForIssuanceCertificates());
      dispatch(getUsersLibrary());
      dispatch(getDictionaryOwnerType());
      dispatch(getDictionaryGimsSections());
      dispatch(getTrainingProgramLibrary());
      dispatch(getAuditObject());
      dispatch(getApplicationRegLibrary());
      dispatch(getValidZonesLibrary());
      dispatch(getValidTypesLibrary());
      dispatch(getGimsDepartmentAll());
      dispatch(getAllCountries());
      dispatch(getAllTrainingOrganizations());
      dispatch(getAllOblast());
      dispatch(getAllGimsUserPositions());
      dispatch(getAllSwimmingDifficultyCategory());
      dispatch(getAllPreparationPrograms());
      dispatch(getAllPaymentDetails());
      dispatch(getAllLocalityCategory());
      dispatch(getAllIdentificationDocuments());
      dispatch(getAllMedConditions());
      dispatch(getAllTrainingDocTypes());
      dispatch(getAllTrainingExamTypes());
      dispatch(getAllBoatTypes());
      dispatch(getAllEngineTypes());
      dispatch(getAllBoatBodyMaterial());
      dispatch(getAllKindsBoats());
      dispatch(getAllRoles());
      dispatch(menuChaptersAll());
      dispatch(menuActionsAll());
      dispatch(getAllRangeMS());
      dispatch(getNsiAp());
      dispatch(getAllBillStatus());
      dispatch(getAllPaidProcTypes());
      dispatch(getAllInfPaymentAp());
      dispatch(getAllAuditSecurityEvents());
      dispatch(getGimsSubLevels());
    }
  }, [dispatch, authLoginReducer.authData.isLogin]);

  useEffect(() => {
    if (refreshToken && !isMaintenance) {
      dispatch(actionRefreshToken());
    }
  }, []);

  useEffect(() => {
    if (userId && refreshToken && !isMaintenance && authLoginReducer.authData.isLogin) {
      dispatch(getMenuNames());
      dispatch(getUserInfoById(userId));
      dispatch(getMenuStructByUserId(userId));
      dispatch(availableChaptersByUseId(userId));
    }
  }, [userId, authLoginReducer.authData.isLogin]);

  useEffect(() => {
    if (window.location.pathname.includes("login")) {
      setIsLoginApp("");
    } else {
      setIsLoginApp("login");
    }
  }, [window.location.href]);

  useEffect(() => {
    if (isAuthorized === "false") {
      Cookies.remove("login");
    }
  }, [isAuthorized]);

  return (
    <Router>
      <Header
        isLogin={authLoginReducer.authData.isLogin}
        isMaintenance={isMaintenance}
        handleLogin={handleLogin}
      />
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        setShow={setShowNotificationWindow}
        messageText={textNotificationWindow}
        onClose={closeInactivityNotification}
      />
      {isMaintenance && <MaintenancePage />}
      {!isMaintenance && !isLogin && <LoginPage handleLogin={handleLogin} />}
      {!isMaintenance && isLogin && isAuthorized === "true" && <FirstLoginPage handleLogin={handleLogin} />}
      {!isMaintenance && isLogin && isAuthorized === "false" && (
        <div className="wrapper">
          <Sidebar />
          <div className="routes-container">
            <Routes>
              <Route
                path="*"
                element={<PageRedirection />}
              />
              <Route
                path="/login"
                element={<LoginPage />}
              />
              <Route
                path="/access-denied"
                element={<AccessDenied />}
              />
              <Route
                path="/smallboats"
                element={
                  <PrivateRoute
                    chapter="SMALL_BOATS"
                    component={SmallBoats}
                  />
                }
              />
              <Route
                path="/certificates"
                element={
                  <PrivateRoute
                    chapter="CERTIFICATES"
                    component={Certificates}
                  />
                }
              />
              <Route
                path="*"
                element={<PageRedirection />}
              />
              <Route
                path="/login"
                element={<LoginPage />}
              />
              <Route
                path="/smallboats/view/:id"
                element={<BoatInfo />}
              />
              <Route
                path="/smallboats/edit/:id"
                element={<BoatInfo />}
              />
              <Route
                path="/certificates"
                element={<Certificates />}
              />
              <Route
                path="/certificates/licenseId/view/:id"
                element={
                  <PrivateRoute
                    chapter="CERTIFICATES"
                    component={Certificate}
                  />
                }
              />
              <Route
                path="/certificates/licenseId/edit/:id"
                element={
                  <PrivateRoute
                    chapter="CERTIFICATES"
                    component={Certificate}
                  />
                }
              />
              <Route
                path="/basesbuilding"
                element={
                  <PrivateRoute
                    chapter="BASES_BUIDING"
                    component={BasesBuildings}
                  />
                }
              />
              <Route
                path="/smallboatsreg"
                element={
                  <PrivateRoute
                    chapter="SMALL_BOATS_REG"
                    component={SmallBoatsRegistration}
                  />
                }
              />
              <Route
                path="/smallboatsreg/app/individual"
                element={<AppBoatRegistrationRHF />}
              />
              <Route
                path="/smallboatsreg/app/entity"
                element={<AppBoatRegistrationRHF />}
              />
              <Route
                path="/smallboatsreg/view/individual/:id"
                element={<AppBoatRegistrationRHF />}
              />
              <Route
                path="/smallboatsreg/view/entity/:id"
                element={<AppBoatRegistrationRHF />}
              />
              <Route
                path="/smallboatsreg/decisioncard/:id"
                element={<DecisionCardRHF />}
              />
              <Route
                path="/reginformationchanges"
                element={
                  <PrivateRoute
                    chapter="REG_INFORMATION_CHANGES"
                    component={RegistrationInformationChanges}
                  />
                }
              />
              <Route
                path="/reginformationchanges/searchboatcard"
                element={<FormSearchBoatCard />}
              />
              <Route
                path="/reginformationchanges/individual/add"
                element={<RegistrationChangesInformationRHFNew />}
              />
              <Route
                path="/reginformationchanges/entity/add"
                element={<RegistrationChangesInformationRHFNew />}
              />
              <Route
                path="/reginformationchanges/statement/:id"
                element={<IndividualStatement />}
              />
              <Route
                path="/reginformationchanges/decisioncard/:id"
                element={<DecisionCardRHF />}
              />
              <Route
                path="/dupshipsticket"
                element={
                  <PrivateRoute
                    chapter="DUPSHIPS_TICKET"
                    component={DuplicateShipsTicket}
                  />
                }
              />
              <Route
                path="/dupshipsticket/searchboatcard"
                element={<FormSearchBoatCard />}
              />
              <Route
                path="/dupshipsticket/add/:id"
                element={<DuplShipsTicketRHF />}
              />
              <Route
                path="/dupshipsticket/view/:id"
                element={<DuplShipsTicketRHF />}
              />
              <Route
                path="/dupshipsticket/decisioncard/:id"
                element={<DecisionCardRHF />}
              />
              <Route
                path="/shipsticket"
                element={
                  <PrivateRoute
                    chapter="SHIPS_TICKET"
                    component={ShipsTicket}
                  />
                }
              />
              <Route
                path="/shipsticket/decisioncard/boatCardAppId/:id"
                element={<DecisionCardRHF />}
              />
              <Route
                path="/shipsticket/decisioncard/boatCardModifId/:id"
                element={<DecisionCardRHF />}
              />
              <Route
                path="/provisioninformation"
                element={
                  <PrivateRoute
                    chapter="PROVISION_INFORMATION"
                    component={ProvisionInformation}
                  />
                }
              />
              <Route
                path="/provisioninformation/individual/add"
                element={<StatementProvisionInformationRHF />}
              />
              <Route
                path="/provisioninformation/entity/add"
                element={<StatementProvisionInformationRHF />}
              />
              <Route
                path="/provisioninformation/statement/:id"
                element={<StatementProvisionInformationRHF />}
              />
              <Route
                path="/provisioninformation/decisioncard/:id"
                element={<StatementProvisionInformationRHF />}
              />
              <Route
                path="/logbookAdministrativeProcedures"
                element={
                  <PrivateRoute
                    chapter="LOGBOOK_ADMINISTRATIVE_PROCEDURES"
                    component={LogbookAdministrativeProcedures}
                  />
                }
              />
              <Route
                path="techexamination"
                element={
                  <PrivateRoute
                    chapter="TECH_EXAMINATION"
                    component={TechnicalExaminationContainer}
                  />
                }
              />
              <Route
                path="/techexamination/searchboatcard"
                element={<FormSearchBoatCard />}
              />
              <Route
                path="/techexamination/individual/add/:id"
                element={<TechnicalExaminationAppRHF />}
              />
              <Route
                path="/techexamination/entity/add/:id"
                element={<TechnicalExaminationAppRHF />}
              />
              <Route
                path="/techexamination/individual/view/:id"
                element={<TechnicalExaminationAppRHF />}
              />
              <Route
                path="/techexamination/entity/view/:id"
                element={<TechnicalExaminationAppRHF />}
              />
              <Route
                path="/techexamination/individual/edit/:id"
                element={<TechnicalExaminationAppRHF />}
              />
              <Route
                path="/techexamination/entity/edit/:id"
                element={<TechnicalExaminationAppRHF />}
              />
              <Route
                path="/inspectorworkstat"
                element={
                  <PrivateRoute
                    chapter="INSPECTOR_WORKSTAT"
                    component={InspectorWorkStat}
                  />
                }
              />
              <Route
                path="/reports"
                element={
                  <PrivateRoute
                    chapter="REPORTS"
                    component={Reports}
                  />
                }
              />
              <Route
                path="/nsi"
                element={
                  <PrivateRoute
                    chapter="NSI"
                    component={NSI}
                  />
                }
              />
              <Route
                path="/nsi/classificationBoats"
                element={<ClassificationBoats />}
              />
              <Route
                path="/nsi/legislation"
                element={<Legislation />}
              />
              <Route
                path="/nsi/forms"
                element={<Forms />}
              />
              <Route
                path="/nsi/paidproc"
                element={<PaidProcedures />}
              />
              <Route
                path="/nsi/requisites"
                element={<Requisite />}
              />
              <Route
                path="/nsi/contacts"
                element={<Contacts />}
              />
              <Route
                path="/nsi/contacts/department/:id"
                element={<DepartmentInfo />}
              />
              <Route
                path="/nsi/contacts/section/:id"
                element={<SectionInfo />}
              />
              <Route
                path="/nsi/adminproc"
                element={<AdministrativeProcedures />}
              />
              <Route
                path="/transportaccidents"
                element={
                  <PrivateRoute
                    chapter="BOAT_INCIDENTS"
                    component={TransportAccidentsReport}
                  />
                }
              />
              <Route
                path="/transportaccidents/add"
                element={<TransportAccidentFormRHF />}
              />
              <Route
                path="/transportaccidents/accident/:id"
                element={<TransportAccidentFormRHF />}
              />
              <Route
                path="/reports/weeklyreport"
                element={<WeeklyReport />}
              />
              <Route
                path="/reports/trafficaccidentsreport"
                element={<ReportTrafficAccidents />}
              />
              <Route
                path="/reports/certificateissuancereport"
                element={<CertificateIssuanceReport />}
              />
              <Route
                path="/reports/paidservicesreport"
                element={<PaidServicesReport />}
              />
              <Route
                path="/reports/quarterlyreport"
                element={<QuarterlyReport />}
              />
              <Route
                path="/reports/quarterlyreport"
                element={<QuarterlyReport />}
              />
              <Route
                path="/reports/graphs"
                element={<GraphsReport />}
              />
              <Route
                path="/reports/shortreport"
                element={<ShortReport />}
              />
              <Route
                path="/reports/training-report"
                element={<TrainingReport />}
              />
              <Route
                path="applicationfortraining"
                element={
                  <PrivateRoute
                    chapter="TRAINING_APP"
                    component={SearchApplicationTraining}
                  />
                }
              />
              <Route
                path="/applicationfortraining/add"
                element={<CardApplicationTrainingRHF />}
              />
              <Route
                path="/applicationfortraining/view/:id"
                element={<CardApplicationTrainingRHF />}
              />
              <Route
                path="/applicationfortraining/edit/:id"
                element={<CardApplicationTrainingRHF />}
              />
              <Route
                path="listenerTracking"
                element={
                  <PrivateRoute
                    chapter="LISTENER_TRACKING"
                    component={SearchExpulsionOrder}
                  />
                }
              />
              <Route
                path="listenerTracking/add"
                element={<CardExpulsionOrder />}
              />
              <Route
                path="/listenerTracking/add/searchListener"
                element={<SearchListener />}
              />
              <Route
                path="/registeroftrainees"
                element={
                  <PrivateRoute
                    chapter="TRAINING_LOG"
                    component={RegisterOfTrainees}
                  />
                }
              />
              <Route
                path="listenerTracking/view/"
                element={<CardExpulsionOrder />}
              />
              <Route
                path="/record-trained-user-logbook"
                element={
                  <PrivateRoute
                    chapter="RECORD_TRAINED_USER_LOGBOOK"
                    component={RecordTrainedUsersLogbook}
                  />
                }
              />
              <Route
                path="record-trained-users"
                element={
                  <PrivateRoute
                    chapter="TRAINING_REGISTER"
                    component={SearchRecordTrainedUsers}
                  />
                }
              />
              <Route
                path="record-trained-users/add"
                element={<CardRecordTrainedUsers />}
              />
              <Route
                path="app-knowledge-verification"
                element={
                  <PrivateRoute
                    chapter="TRAINING_CHECK_APP"
                    component={AppKnowledgeVerificationSearch}
                  />
                }
              />
              <Route
                path="app-knowledge-verification/add"
                element={<AppKnowledgeVerificationRHF />}
              />
              <Route
                path="app-knowledge-verification/edit/:id"
                element={<AppKnowledgeVerificationRHF />}
              />
              <Route
                path="app-knowledge-verification/view/:id"
                element={<AppKnowledgeVerificationRHF />}
              />
              <Route
                path="record-trained-users/view"
                element={<CardRecordTrainedUsers />}
              />
              <Route
                path="record-trained-users/edit/:id"
                element={<CardRecordTrainedUsers />}
              />
              <Route
                path="knoweledge-test-record"
                element={
                  <PrivateRoute
                    chapter="TRAINING_CHECK"
                    component={SearchKnowledgeTestRecord}
                  />
                }
              />
              <Route
                path="issuing-certificates"
                element={
                  <PrivateRoute
                    chapter="ISSUING_CERTIFICATES"
                    component={IssuingCertificatesSearch}
                  />
                }
              />
              <Route
                path="issuing-certificates/applicant-search"
                element={<FormSearchApplicant />}
              />
              <Route
                path="knoweledge-test-record/add"
                element={<CardKnowledgeTestRecord />}
              />
              <Route
                path="knoweledge-test-record/add/searchPeople"
                element={<SearchPeopleForTest />}
              />
              <Route
                path="knoweledge-test-record/edit/:id"
                element={<CardKnowledgeTestRecord />}
              />
              <Route
                path="knoweledge-test-record/view/:id"
                element={<CardKnowledgeTestRecord />}
              />

              <Route
                path="issuing-certificates/republican/add/:id"
                element={<IssuingCertificatesAppRHF />}
              />
              <Route
                path="issuing-certificates/international/add/:id"
                element={<IssuingCertificatesAppRHF />}
              />
              <Route
                path="issuing-certificates/view/:id"
                element={<IssuingCertificatesAppRHF />}
              />
              <Route
                path="print-certificates"
                element={
                  <PrivateRoute
                    chapter="PRINT_CERTIFICATES"
                    component={SearchCertificatesForPrint}
                  />
                }
              />
              <Route
                path="print-certificates/view/:id"
                element={<CertificateCardForPrint />}
              />
              <Route
                path="print-certificates/edit/:id"
                element={<CertificateCardForPrint />}
              />
              <Route
                path="checksAndAudits"
                element={
                  <PrivateRoute
                    chapter="BOAT_PARKING_CHECKS"
                    component={InspectionTechnicalConditionBases}
                  />
                }
              />
              <Route
                path="exchange-certificates"
                element={
                  <PrivateRoute
                    chapter="EXCHAGE_CERTIFICATES"
                    component={ExchangeCertificatesSearch}
                  />
                }
              />
              <Route
                path="exchange-certificates"
                element={
                  <PrivateRoute
                    chapter="EXCHAGE_CERTIFICATES"
                    component={ExchangeCertificatesAppRHF}
                  />
                }
              />
              <Route
                path="exchange-certificates/add/republican"
                element={<ExchangeCertificatesAppRHF />}
              />
              <Route
                path="exchange-certificates/add/international"
                element={<ExchangeCertificatesAppRHF />}
              />
              <Route
                path="exchange-certificates/view/:id"
                element={<ExchangeCertificatesAppRHF />}
              />
              <Route
                path="duplicate-certificates"
                element={<DuplicateCertificatesSearch />}
              />
              <Route
                path="duplicate-certificates/add/republican"
                element={<DuplicateCertificatesAppRHF />}
              />
              <Route
                path="duplicate-certificates/add/international"
                element={<DuplicateCertificatesAppRHF />}
              />
              <Route
                path="duplicate-certificates/view/:id"
                element={<DuplicateCertificatesAppRHF />}
              />
              <Route
                path="maintainingDirectories"
                element={
                  <PrivateRoute
                    chapter="EDIT_REF_BOOKS"
                    component={MaintainingDirectories}
                  />
                }
              />
              <Route
                path="maintainingDirectories/structuralUnits"
                element={<StructuralUnits />}
              />
              <Route
                path="maintainingDirectories/gimsSections"
                element={<GimsSections />}
              />
              <Route
                path="/maintainingDirectories/administrativeDistricts"
                element={<AdministrativeDistricts />}
              />
              <Route
                path="/maintainingDirectories/identification-documents"
                element={<IdentificationDocuments />}
              />
              <Route
                path="/maintainingDirectories/positions"
                element={<Positions />}
              />
              <Route
                path="/maintainingDirectories/swimmingDifficultyCategory"
                element={<SwimmingDifficultyCategory />}
              />
              <Route
                path="/maintainingDirectories/preparationPrograms"
                element={<PreparationPrograms />}
              />
              <Route
                path="/maintainingDirectories/paymentDetails"
                element={<PaymentDetails />}
              />
              <Route
                path="/maintainingDirectories/settlements"
                element={<Settlements />}
              />
              <Route
                path="/maintainingDirectories/medConditions"
                element={<MedConditions />}
              />
              <Route
                path="/maintainingDirectories/rangeMS"
                element={<RangeMS />}
              />
              <Route
                path="/maintainingDirectories/trainingDocTypes"
                element={<TrainingDocTypes />}
              />
              <Route
                path="/maintainingDirectories/boat-types"
                element={<BoatTypes />}
              />
              <Route
                path="/maintainingDirectories/kinds-boats"
                element={<KindsBoats />}
              />
              <Route
                path="/maintainingDirectories/engineType"
                element={<EngineType />}
              />
              <Route
                path="/maintainingDirectories/boatBodyMaterial"
                element={<BoatBodyMaterial />}
              />
              <Route
                path="/maintainingDirectories/countries"
                element={<Countries />}
              />
              <Route
                path="/maintainingDirectories/organizations"
                element={<Organizations />}
              />
              <Route
                path="patterns/*"
                element={
                  <PrivateRoute
                    chapter="PATTERNS"
                    component={ManagementTemplates}
                  />
                }
              />
              <Route
                path="roleManagement"
                element={
                  <PrivateRoute
                    chapter="ROLE_MANAGMENT"
                    component={RoleManagement}
                  />
                }
              />
              <Route
                path="accountManagement"
                element={
                  <PrivateRoute
                    chapter="ACCOUNT_MANAGEMENT"
                    component={AccountManagement}
                  />
                }
              />
              <Route
                path="accountManagement/workingPage"
                element={<WorkingPage />}
              />
              <Route
                path="auditActionsSystem"
                element={
                  <PrivateRoute
                    chapter="AUDIT_USERS_ACTIONS"
                    component={AuditActionsSystem}
                  />
                }
              />
              <Route
                path="auditSecurity"
                element={
                  <PrivateRoute
                    chapter="AUDIT_SECURITY"
                    component={AuditSecurity}
                  />
                }
              />
            </Routes>
          </div>
        </div>
      )}
    </Router>
  );
}

export default App;
